import React from 'react';

export const Move = ({ height="31px", width="36px",padding="12px",style=''})=> (
    <svg  role="presentation" aria-label="" padding={padding} width={width} height={height} viewBox="0 0 36 31" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <linearGradient x1="77.3826171%" y1="101.912452%" x2="32.4552426%" y2="20.441989%" id="linearGradient-1">
                <stop stopColor="#C47500" offset="0%" />
                <stop stopColor="#EE8D00" offset="100%" />
            </linearGradient>
        </defs>
        <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Package-Shipment" transform="translate(-2.000000, -5.000000)">
                <g>
                    <rect id="Mask" x="0" y="0" width="40" height="40" rx="2" />
                    <g id="Group-4" transform="translate(2.000000, 5.000000)">
                        <polygon id="Rectangle-Copy-44" fill="#8D5D03" points="0 6.73913043 18 13.4782609 18 31 0 24.2608696" />
                        <polygon id="Rectangle-Copy-43" fill="#A86F02" points="0 6.73913043 18 13.4782609 36 6.73913043 18 0" />
                        <polygon id="Rectangle-Copy-42" fill="#D78F05" points="25.8122243 10.5322374 28.5814551 9.50124765 11.5696753 2.40138617 8.28888304 3.62990777" />
                        <polygon id="Rectangle-Copy-41" fill="url(#linearGradient-1)" fillRule="nonzero" points="18 13.4782609 36 6.73913043 36 24.2608696 18 31" />
                        <path d="M18.6997838,12.8966887 L17.1726636,30.3517523 C26.3592585,27.7959545 31.5841417,26.3432333 32.8473131,25.9935887 C30.1440243,24.8742473 24.8483208,22.1768238 22.6698937,17.3474282 C21.9021991,15.6335975 21.5945184,13.8377196 21.7605396,12.0508813 C21.2952803,12.1437932 20.2750283,12.425729 18.6997838,12.8966887 Z" id="Shape-Copy-15" fillOpacity="0.8" fill="#C47500" fillRule="nonzero" transform="translate(25.009988, 21.201317) rotate(-5.000000) translate(-25.009988, -21.201317) " />
                        <polygon id="Rectangle-Copy-40" fill="#FFA700" points="25.8122243 10.5322374 28.5814551 9.50124765 28.5814551 14.5122321 25.8122243 15.6358965" />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);
